import { useEffect, useState } from "react"
import { cachedProducts, fetchProducts } from "../services/websiteProducts"

export default function useWebsiteProducts() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let alive = true

    const cached = cachedProducts()
    if (cached.length) {
      setProducts(cached)
      setLoading(false)
    }

    fetchProducts()
      .then(next => {
        if (!alive) return
        setProducts(next)
        setError(null)
        setLoading(false)
      })
      .catch(fetchError => {
        if (!alive) return
        setError(fetchError)
        setLoading(false)
      })

    return () => {
      alive = false
    }
  }, [])

  return { products, loading, error }
}
